import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/brands/salvus.png'


const _withScopeId = n => (_pushScopeId("data-v-7f6740ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Salvus Health",
      style: {"height":"20px","margin-top":"-0.4em"}
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Salvus Health")
  ])
], -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_8 = {
  key: 1,
  class: "bg-warning missing-feature"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('calendarSettings'),
        mb: 4
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('salvusSettingsInfo')
              }, null, 8, _hoisted_6),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'pharma-appointments-salvus-health'},
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}